import React from 'react';
import styled from 'styled-components';
import type { FieldArrayMethodProps, FieldArrayWithId } from 'react-hook-form';

import { TotemSelect } from 'components/TotemSelect';
import { GetEquipmentsQuery } from 'data/__generated__';

type EquipmentType = { equipmentId: string; quantity: number; comment: string };
type EquipmentFields = FieldArrayWithId<
    {
        equipments: EquipmentType[];
    },
    'equipments',
    'id'
>[];

export const EquipmentSelector = ({
    append,
    equipmentFields,
    equipments,
}: {
    append: (
        value: { equipmentId: string; quantity: number; comment: string },
        options?: FieldArrayMethodProps | undefined,
    ) => void;
    equipmentFields: EquipmentFields;
    equipments: GetEquipmentsQuery['adminEquipments'];
}) => {
    const onSelect = (value: string | null) => {
        if (value && !equipmentFields.some(({ equipmentId }) => equipmentId === value)) {
            append({ equipmentId: value, quantity: 0, comment: '' });
        }
    };

    const equipmentOptions = equipments.map(({ _id, fullname }: { _id: string; fullname: string }) => ({
        value: _id,
        label: fullname,
    }));

    return (
        <SelectorContainer>
            <TotemSelect
                label="Ajouter un equipment"
                placeholder="Recherche par nom ou par _id"
                value={null}
                options={equipmentOptions}
                onChange={onSelect}
            />
        </SelectorContainer>
    );
};

const SelectorContainer = styled.div`
    width: 100%;
    font-size: 15px;
`;
